<app-overlay *ngIf="$loading()"></app-overlay>
<router-outlet />
